function init() {
  document.querySelectorAll('.js-navigation__trigger').forEach((trigger) => {
    trigger.addEventListener('click', () =>
      document.querySelector('.navigation').classList.toggle('navigation--visible')
    );
  });
}

export { init };
